import React from 'react';

import { Link } from 'react-router-dom';

function WhatdeclarationMeansForClients() {
  return (
    <>

      <div className="bg-[#F9FAFB] min-h-screen">
        {/* Header Section */}
        <div className="bg-white border-b border-gray-200">
          <div className="max-w-4xl mx-auto px-6 py-16 text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-[#102A43] mb-6">What declaration Means for Clients</h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
              A transparent guide to understanding the value, scope, and limitations of AASC accountability declaration when selecting an organization using AI partner.
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-6 py-12 space-y-12">

          {/* Section 1: Why This Exists */}
          <section className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100">
            <div className="bg-gradient-to-r from-blue-900 to-blue-800 px-8 py-4">
              <h2 className="text-xl font-bold text-white">1. Why This Exists</h2>
            </div>
            <div className="p-8 text-[#64748B] leading-relaxed">
              <p>
                The AI services market is rapidly evolving and largely unregulated. It can be difficult for clients to distinguish between agencies that have established rigorous operational controls and those that are experimenting without safety nets.
              </p>
              <p className="mt-4">
                AASC accountability declaration exists to provide a <strong>baseline guard rail</strong>. It offers an objective, verifiable signal that an agency has documented its adherence to specific technical standards regarding human oversight, accountability, and workflow readiness.
              </p>
            </div>
          </section>

          {/* Section 2: What declaration Confirms */}
          <section className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100">
            <div className="px-8 py-6 border-b border-gray-100">
              <h2 className="text-xl font-bold text-[#102A43]">2. What declaration Confirms</h2>
            </div>
            <div className="p-8 text-[#64748B] leading-relaxed">
              <p className="mb-4">When an agency holds an active AASC accountability declaration, it confirms that:</p>
              <ul className="list-disc pl-5 space-y-3">
                <li>
                  <strong>Documented Conformance:</strong> The agency has submitted evidence (logs, policy documents, workflow maps) demonstrating alignment with published standards (e.g., <em>Human-in-the-Loop Control</em>, <em>AI Outcome Accountability</em>).
                </li>
                <li>
                  <strong>Point-in-Time Evaluation:</strong> The agency met these requirements at the time of their assessment or renewal.
                </li>
                <li>
                  <strong>Defined Scope:</strong> The agency has declared which parts of their organization (specific teams or the whole entity) operate under these controls.
                </li>
              </ul>
            </div>
          </section>

          {/* Section 3: What declaration Does Not Confirm */}
          <section className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100">
            <div className="px-8 py-6 border-b border-gray-100">
              <h2 className="text-xl font-bold text-[#102A43]">3. What declaration Does Not Confirm</h2>
            </div>
            <div className="p-8">
              <div className="bg-[#F9FAFB] p-6 rounded-lg border-l-4 border-gray-400 text-[#64748B] space-y-4">
                <p><strong>It is NOT a guarantee of outcome:</strong> Declaration does not ensure that an AI project will be profitable or successful.</p>
                <p><strong>It is NOT regulatory compliance:</strong> Declaration does not verify compliance with laws such as the EU AI Act, GDPR, or HIPAA.</p>
                <p><strong>It is NOT legal advice:</strong> The Council is a technical standards body, not a legal firm.</p>
                <p><strong>It is NOT a continuous audit:</strong> The Council does not monitor the agency's daily operations in real-time.</p>
              </div>
            </div>
          </section>

          {/* Section 4: Why This Matters to Clients */}
          <section className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100">
            <div className="px-8 py-6 border-b border-gray-100">
              <h2 className="text-xl font-bold text-[#102A43]">4. Why This Matters to Clients</h2>
            </div>
            <div className="p-8 text-[#64748B] leading-relaxed">
              <p className="mb-4">
                Despite the limitations, declaration matters because it demonstrates <strong>operational maturity</strong>.
              </p>
              <p>
                Working with a declared organization reduces risk. It means you are partnering with an organization that has formally defined who is responsible for AI outcomes and has established protocols for when human intervention is required. It suggests the agency takes its professional obligations seriously enough to undergo voluntary external review.
              </p>
            </div>
          </section>

          {/* Section 5: How to Verify */}
          <section className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100">
            <div className="px-8 py-6 border-b border-gray-100">
              <h2 className="text-xl font-bold text-[#102A43]">5. How to Verify</h2>
            </div>
            <div className="p-8 text-[#64748B] leading-relaxed">
              <p className="mb-6">
                Trust but verify. Clients should never rely solely on a logo on a slide deck.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="/verify-credential" className="flex items-center justify-center px-6 py-3 bg-[#2F80ED] text-white font-semibold rounded-sm hover:bg-[#2563eb] transition-colors">
                  Search the Public Registry
                </a>
                <Link to="/declaration-mark-usage-policy" className="flex items-center justify-center px-6 py-3 bg-white border border-[#E2E8F0] text-[#64748B] font-semibold rounded-sm hover:bg-[#F9FAFB] transition-colors">
                  View Mark Usage Policy
                </Link>
              </div>
            </div>
          </section>

          {/* Section 6: Final Perspective */}
          <section className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100">
            <div className="px-8 py-6 border-b border-gray-100">
              <h2 className="text-xl font-bold text-[#102A43]">6. Final Perspective</h2>
            </div>
            <div className="p-8 text-[#64748B] leading-relaxed">
              <p className="italic text-gray-600 mb-4 text-center">
                "AASC serves as a baseline guard rail for organization using AI operations and does not replace legal review, regulatory compliance, or other declaration frameworks."
              </p>
              <p>
                We encourage all clients to discuss these standards with their agency partners and to use the declaration as a starting point for a deeper conversation about risk management and operational quality.
              </p>
            </div>
          </section>

          <div className="text-center pt-8 pb-4">
             <Link to="/tier-1-baseline-declaration" className="text-[#2F80ED] hover:underline font-medium">
               Learn about Tier 1 Baseline declaration
             </Link>
          </div>

        </div>
      </div>
    </>
  );
}

export default WhatdeclarationMeansForClients;